/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Form_Clients_Clear_SearchInputs */

const en_users_form_clients_clear_search = /** @type {(inputs: Users_Form_Clients_Clear_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear client search`)
};

const pt_br2_users_form_clients_clear_search = /** @type {(inputs: Users_Form_Clients_Clear_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpar busca de clientes`)
};

/**
* | output |
* | --- |
* | "Clear client search" |
*
* @param {Users_Form_Clients_Clear_SearchInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_form_clients_clear_search = /** @type {((inputs?: Users_Form_Clients_Clear_SearchInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Form_Clients_Clear_SearchInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_form_clients_clear_search(inputs)
	return pt_br2_users_form_clients_clear_search(inputs)
});